/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { HFlow, Text, VFlow } from 'bold-ui'
import useSession from 'components/auth/useSession'
import { CheckboxField, TextField, usePecField } from 'components/form'
import { InfoIcon } from 'components/InfoIcon'
import { useConfiguracoesQuery } from 'graphql/hooks.generated'
import Permissions from 'types/Permissions'
import { MetaRoot } from 'util/metaPath'

import { ComprovanteAgendamentoSectionModel } from './model-agendarConsultaAtendimento'

export interface ComprovanteAgendamentoSectionProps {
  name: MetaRoot<ComprovanteAgendamentoSectionModel>
  maisDeUmComprovante: boolean
}

export function ComprovanteAgendamentoSection(props: Readonly<ComprovanteAgendamentoSectionProps>) {
  const { name, maisDeUmComprovante } = props

  const { checkAuthorization } = useSession()

  const possuiAutorizacaoAlterarEmail = checkAuthorization(
    Permissions.gestaoDeCadastrosDeCidadao.visualizarCidadao.cadastrarEEditar
  )

  const {
    data: { info: { smtpConfigurado } = {} },
  } = useConfiguracoesQuery({
    fetchPolicy: 'cache-first',
  })

  const {
    input: { value: enviarParaCidadaoChecked },
  } = usePecField({ name: name.enviarParaCidadao, subscription: { value: true } })

  const comprovanteString = maisDeUmComprovante ? 'comprovantes' : 'comprovante'

  return (
    <div css={styles.container}>
      <VFlow>
        <Text variant='h5'>Comprovantes de agendamento</Text>
        {smtpConfigurado && possuiAutorizacaoAlterarEmail && (
          <VFlow vSpacing={0.5}>
            <HFlow alignItems='center' hSpacing={0.5}>
              <CheckboxField
                name={name.enviarParaCidadao}
                label={`Enviar ${comprovanteString} por e-mail ao cidadão`}
                style={styles.checkbox}
              />
              <InfoIcon
                icon='infoCircleFilled'
                text='Verifique o e-mail do cidadão ao agendar. O cadastro do cidadão será atualizado com os dados adicionados.'
              />
            </HFlow>
            {enviarParaCidadaoChecked && (
              <div css={styles.email}>
                <TextField
                  lowercase
                  name={name.emailCidadao}
                  label='E-mail'
                  maxLength={50}
                  required
                  disabled={!possuiAutorizacaoAlterarEmail}
                />
              </div>
            )}
          </VFlow>
        )}
        <CheckboxField
          name={name.imprimir}
          label={`Imprimir ${comprovanteString} ao finalizar atendimento`}
          style={styles.checkbox}
        />
      </VFlow>
    </div>
  )
}

const styles = {
  container: css`
    padding: 1rem;
    padding-top: 0;
  `,
  email: css`
    width: 22.5rem;
    margin-left: 2rem;
  `,
  checkbox: css`
    margin-left: -0.25rem;
  `,
}
